import { render } from "./VirtualCareBanner.vue?vue&type=template&id=29ceaf33&scoped=true&ts=true"
import script from "./VirtualCareBanner.vue?vue&type=script&lang=ts"
export * from "./VirtualCareBanner.vue?vue&type=script&lang=ts"

import "./VirtualCareBanner.vue?vue&type=style&index=0&id=29ceaf33&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29ceaf33"]])

export default __exports__